import api from '../config/axios';
import KEEP_ALIVE_CONFIG from '../config/keepAlive';

class KeepAliveService {
  constructor() {
    this.intervalId = null;
    this.pingInterval = KEEP_ALIVE_CONFIG.PING_INTERVAL;
    this.isRunning = false;
    this.enabled = KEEP_ALIVE_CONFIG.ENABLED;
    this.verbose = KEEP_ALIVE_CONFIG.VERBOSE_LOGGING;
    this.endpoint = KEEP_ALIVE_CONFIG.HEALTH_ENDPOINT;
  }

  /**
   * Start the keep-alive service
   * Pings the backend every 10 minutes to prevent hibernation
   */
  start() {
    if (!this.enabled) {
      console.log('Keep-alive service is disabled in configuration');
      return;
    }

    if (this.isRunning) {
      if (this.verbose) {
        console.log('Keep-alive service is already running');
      }
      return;
    }

    if (this.verbose) {
      console.log('Starting keep-alive service...');
      console.log(`Ping interval: ${this.pingInterval / 1000 / 60} minutes`);
    }
    this.isRunning = true;

    // Ping immediately on start
    this.ping();

    // Set up interval to ping every configured interval
    this.intervalId = setInterval(() => {
      this.ping();
    }, this.pingInterval);
  }

  /**
   * Stop the keep-alive service
   */
  stop() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
      this.isRunning = false;
      if (this.verbose) {
        console.log('Keep-alive service stopped');
      }
    }
  }

  /**
   * Ping the backend to keep it awake
   */
  async ping() {
    try {
      const response = await api.get(this.endpoint);
      if (this.verbose) {
        console.log('✓ Keep-alive ping successful:', new Date().toLocaleTimeString());
      }
      return response.data;
    } catch (error) {
      // Silently fail - don't disrupt user experience
      if (this.verbose) {
        console.warn('✗ Keep-alive ping failed:', error.message);
      }
    }
  }

  /**
   * Check if the service is running
   */
  isActive() {
    return this.isRunning;
  }
}

// Export singleton instance
const keepAliveService = new KeepAliveService();
export default keepAliveService;
